import * as React from "react";

export const Logo = () => {
    return (
        <div className="logo">
            <img src={process.env.PUBLIC_URL + "/logo.png"} alt="OGVG - Ontario Greenhouse Vegetable Growers" />
        </div>
    );
};
